/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpgradeRuleValidateInfoResponse
 */
export interface UpgradeRuleValidateInfoResponse {
    /**
     * The device number.
     * @type {number}
     * @memberof UpgradeRuleValidateInfoResponse
     */
    deviceNumber?: number;
    /**
     * A list of groups.
     * @type {Array<string>}
     * @memberof UpgradeRuleValidateInfoResponse
     */
    groups?: Array<string>;
    /**
     * Flag indicating if rule attached to default or not.
     * @type {boolean}
     * @memberof UpgradeRuleValidateInfoResponse
     */
    attachedToDefaultGroup?: boolean;
}

export function UpgradeRuleValidateInfoResponseFromJSON(json: any): UpgradeRuleValidateInfoResponse {
    return UpgradeRuleValidateInfoResponseFromJSONTyped(json, false);
}

export function UpgradeRuleValidateInfoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpgradeRuleValidateInfoResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'deviceNumber': !exists(json, 'deviceNumber') ? undefined : json['deviceNumber'],
        'groups': !exists(json, 'groups') ? undefined : json['groups'],
        'attachedToDefaultGroup': !exists(json, 'attachedToDefaultGroup') ? undefined : json['attachedToDefaultGroup'],
    };
}

export function UpgradeRuleValidateInfoResponseToJSON(value?: UpgradeRuleValidateInfoResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'deviceNumber': value.deviceNumber,
        'groups': value.groups,
        'attachedToDefaultGroup': value.attachedToDefaultGroup,
    };
}

